var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.766 11a.89.89 0 0 0-.891-.89H9.125a.89.89 0 1 0 0 1.78h13.75a.89.89 0 0 0 .89-.89Zm-4.641 2.234h-10a.89.89 0 1 0 0 1.782h10a.89.89 0 0 0 0-1.782Zm3.75 3.125H9.125a.89.89 0 1 0 0 1.782h13.75a.89.89 0 0 0 0-1.782Zm-3.75 3.125h-10a.89.89 0 1 0 0 1.782h10a.89.89 0 0 0 0-1.782Z"
  })));
};
export default SvgLeft;